import SubmenuItem from './submenuitem';
import React, { useState } from "react";
import t from "../helpers/t";
import Paginator from "./paginator";
import FormItem from "./FormItem";

type Tab = {
    isAccessible: boolean,
    link: string,
    isActive: boolean,
    style?: object
    icon: string,
    name: string,
    data_inb_val: string
};

type Pagination = {
    count: number,
    current_page: number,
    page_count: number,
    has_next_page: boolean,
    has_prev_page: boolean,
    limit: number
};

type MultiSwitchOption = {
    label: any,
    value: any,
    multiEvent: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, value: any) => void
};

type SearchbarOption = {
    id: any,
    name: string
};

type Props = {
    extraStyle?: React.CSSProperties,
    smallOnlyTitle?: string,
    tabs: Tab[],
    searchbar?: boolean,
    searchbarHandler: (ev: React.ChangeEvent<HTMLInputElement>|string) => void,
    searchbarClasses?: string,
    searchbarPlaceholder?: string,
    extraClasses?: string,
    itemLength?: string|number,
    pagination?: Pagination,
    itemsCountPerPage?: number,
    onChange?: (currentPage: number) => void,
    showPagination?: boolean,
    multiSelect?: boolean,
    multiSwitchOptions?: MultiSwitchOption[],
    selectedItemsCount?: number|null,
    model?: string,
    oneItemChecked?: boolean,
    setPaginationLimit?: (limit: number) => void,
    searchbarOptions?: SearchbarOption[],
    searchBarOptionsSelected?: any,
    setSearchBarOptionsSelected?: (selected: any) => void,
    searchbarValue?: string,
    pageRangeDisplayed?: number
}
const InboomaSubmenu = ({ extraStyle,
        smallOnlyTitle,
        tabs,
        searchbar,
        searchbarHandler,
        searchbarClasses,
        searchbarPlaceholder,
        extraClasses,
        itemLength,
        pagination,
        itemsCountPerPage,
        onChange ,
        showPagination=true,
        multiSelect=false,
        multiSwitchOptions,
        selectedItemsCount,
        model,
        oneItemChecked = false,
        setPaginationLimit,
        searchbarOptions,
        searchBarOptionsSelected = null,
        setSearchBarOptionsSelected,
        searchbarValue = ''
    } :Props) =>{
               // initial empty query
    const [query,setQuery] = useState(searchbarValue);            // initial empty query
console.log(pagination, 'pagination')
    // initial empty query
    const [options, setOptions] = useState(searchBarOptionsSelected);
    const [checkBox, setCheckBox] = useState(false);
    const searchbarHandlerInside = (ev: React.ChangeEvent<HTMLInputElement>) => {

        setQuery(ev.target.value);              // just storing the query
        searchbarHandler(ev);             // this should cause the api query
    };

    const resetQuery = () => {
        setOptions('Alle');
        if(typeof setSearchBarOptionsSelected === 'function'){
            setSearchBarOptionsSelected(null);
        }
        setQuery('');
        searchbarHandler('');
        setCheckBox(false);
    };

    const onChangeSearchbarOptions = (e: React.ChangeEvent<HTMLInputElement>) => {
        if(typeof setSearchBarOptionsSelected !== 'undefined') {
            setSearchBarOptionsSelected(e.target.value);
        }
        setOptions(e.target.value);
        if(typeof setSearchBarOptionsSelected === 'function' && e.target.value === 'Alle'){
            setSearchBarOptionsSelected(null);
        } else {
            if(typeof setSearchBarOptionsSelected === 'function') {
                setSearchBarOptionsSelected(e.target.value);
            }
        }
        setQuery('');
        searchbarHandler('');
    }

   /* const onChangeCheckBox = (e: React.ChangeEvent<HTMLInputElement>) => {
        if(!e.target.checked && typeof setSearchBarOptionsSelected !== 'undefined'){
            setSearchBarOptionsSelected(null);
        }
        setCheckBox(e.target.checked);
    }*/

    return(
        <>
            <div id="inb-c-main-access-bar" className={"clearfix "  + (typeof extraClasses !== 'undefined'?extraClasses:"")} style={typeof extraStyle !== 'undefined'?extraStyle:{}}>
                <h1 className="inb-page-title hide-for-xlarge-only hide-for-large-only hide-for-medium-only">{typeof smallOnlyTitle !== 'undefined'?smallOnlyTitle:t('contingents',null,'capital')}</h1>
                <ul className="inb-hor-icon-nav float-left hide-for-medium-only hide-for-small-only ac">
                    {typeof tabs !== 'undefined' && tabs.map((tab,index) => {
                        return(
                            <SubmenuItem
                                tab={tab}
                                key={index}
                            />
                        );
                    })}
                </ul>
                {searchbar !== undefined && searchbar !== null &&
                <>
                    <div id="inb-c-main-access-bar__search" className={"float-right " + (typeof searchbarClasses !== 'undefined'?searchbarClasses:"")}>
                        <input type="text" placeholder={searchbarPlaceholder ? searchbarPlaceholder : ""} value={query} className="inb-input--transparent inb-input--search inb-input--clear" onChange={searchbarHandlerInside}/>
                        {query !== '' && <><div className="inb-search-close" onClick={resetQuery}>
                            <a href="#" className="unset-filter">
                                <i className="fi fi-x"> </i>
                            </a>
                        </div></>}
                </div>
                    {typeof searchbarOptions !== 'undefined' && searchbarOptions !== null && <>
                        {<FormItem
                            name="searchbar_option_id"
                            inputType="select"
                            label=''
                            type="select"
                            dataKey="id"
                            data={searchbarOptions}
                            selected={searchBarOptionsSelected}
                            mediumWidth={6}
                            smallWidth={6}
                            onChangeHandler={onChangeSearchbarOptions}
                           // placeholder={t('please_select')}
                            extraTopClasses="float-right searchbarHeight"/>}
                        {/*  <FormItem
                            name="checkbox"
                            type="checkbox"
                            label={t('filter explicit',null,'capital')}
                            checkBoxStyle={{minWidth:"180px"}}
                            htmlFor={""}
                            value={checkBox}
                            mediumWidth={6}
                            smallWidth={12}
                            switchStyle={{float:'left',paddingLeft:"10px"}}
                            onChangeHandler={onChangeCheckBox}
                            extraTopClasses="float-right searchbarHeight hide-for-small-only"/>*/}
                            <label className="float-right searchbarHeight filterLabel">{t('filter by', null, 'capital')}</label>
                        </>}
                    </>
                }
                {/* {showPagination && typeof pagination !== 'undefined' && typeof initialized !== 'undefined' && typeof itemLength !== 'undefined' && typeof itemsCountPerPage !== 'undefined' && itemLength > 1 &&
                    initialized && itemLength > 0 && */}
                    {showPagination && typeof pagination !== 'undefined' && typeof itemLength !== 'undefined' && parseInt(itemLength.toString()) > 0 &&
                    <div className="sidebar-pagination"><Paginator
                    pagination={pagination}
                    itemsCountPerPage={typeof itemsCountPerPage !== 'undefined'?itemsCountPerPage:40}
                    pageRangeDisplayed={5}
                    onChange={onChange}
                    multiSelect={multiSelect}
                    multiSwitchOptions={multiSwitchOptions}
                    selectedItemsCount={selectedItemsCount}
                    setPaginationLimit={setPaginationLimit}
                    model={model}
                    oneItemChecked={oneItemChecked}
                /></div>}
            </div>
            {/*  <div id="inb-c-main-access-bar" className={"clearfix "  + (typeof extraClasses !== 'undefined'?extraClasses:"")} style={typeof extraStyle !== 'undefined'?extraStyle:{}}>
                {searchbar !== undefined && searchbar != null &&
                    <> <div id="inb-c-main-access-bar__search" className={"float-right " + (typeof searchbarClasses !== 'undefined'?searchbarClasses:"")}style={{width: "65%"}}>
                        <input type="text" placeholder={searchbarPlaceholder ? searchbarPlaceholder : ""} value={query} className="inb-input--transparent inb-input--search inb-input--clear" onChange={searchbarHandlerInside}
                        style={{position:'relative',paddingTop: "67px", paddingBottom: 0, width: "70%", maxWidth:"75%"}}/>
                        {query !== '' && <><div className="inb-search-close" onClick={resetQuery}>
                            <a href="#" className="unset-filter">
                                <i className="fi fi-x"> </i>
                            </a>
                        </div></>}
                    </div></>
                }
                <h1 className="inb-page-title show-for-small-only" style={{width: "35%"}}>{typeof smallOnlyTitle !== 'undefined'?smallOnlyTitle:t('contingents',null,'capital')}</h1>

            </div> */}
            {/* {showPagination && typeof pagination !== 'undefined' && typeof initialized !== 'undefined' && typeof itemLength !== 'undefined' && typeof itemsCountPerPage !== 'undefined' && itemLength > 1 &&
                initialized && itemLength > 0 &&
                <span className="show-for-small-only sidebar-pagination"><Paginator
                    pagination={pagination}
                    itemsCountPerPage={itemsCountPerPage}
                    pageRangeDisplayed={5}
                    onChange={onChange}
                    sidebar={true}
                /></span>} */}
        </>
    );

};

export default InboomaSubmenu;